import { eachDayOfInterval } from 'date-fns';

import type { IWeekListByMonthRaw } from '@/api/types';
import type { IWeekListByMonth } from '@/store/types';

import { dateWithTimeZone } from '@/helpers';

const transformWeeksListByMonth = (weeksListByMonth: IWeekListByMonthRaw[], timeZone?: string): IWeekListByMonth[] => {
  if (weeksListByMonth === undefined || weeksListByMonth.length === 0) return [];

  return weeksListByMonth.map(week => {
    const weekdays = eachDayOfInterval({
      start: timeZone
        ? dateWithTimeZone(new Date(week.startYear, week.startMonth - 1, week.startDay), timeZone)
        : new Date(week.startYear, week.startMonth - 1, week.startDay),
      end: timeZone
        ? dateWithTimeZone(new Date(week.endYear, week.endMonth - 1, week.endDay), timeZone)
        : new Date(week.endYear, week.endMonth - 1, week.endDay),
    }).map(week => week.toDateString());

    return {
      ...week,
      weekdays,
    };
  });
};

export { transformWeeksListByMonth };
